import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, QueryList, ViewChildren, ViewEncapsulation } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { SdBorderWrapperComponent, SdButtonComponent, SdTitleComponent } from '@seb/web-design-system/core';

import type { IOrderProduct } from '../order-details/order-details.interface';
import type { IOrderReturnDetail, IOrderReturnDetailProduct } from './order-return-detail/order-return-detail.interface';
import { SdOrderReturnDetailComponent } from './order-return-detail/order-return-detail.component';

@Component({
  selector: 'sd-order-return',
  templateUrl: './order-return.component.html',
  styleUrls: ['./order-return.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    SdBorderWrapperComponent,
    SdTitleComponent,
    SdOrderReturnDetailComponent,
    SdButtonComponent,
    TranslateModule
  ]
})
export class SdOrderReturnComponent {
  productsSelected: IOrderReturnDetailProduct[] = [];

  @Input()
  titleLevel = 4;

  @Input()
  orderProducts: IOrderProduct[];

  @Input()
  returnListConfig: IOrderReturnDetail;

  @Input()
  canReturnProduct = false;

  @Output()
  productSelectedDetails = new EventEmitter<IOrderReturnDetailProduct[]>();

  @Output()
  printTicket = new EventEmitter<void>();

  @Output()
  printDetails = new EventEmitter<void>();

  @Output()
  openRecommendedPriceModal = new EventEmitter<void>();

  @ViewChildren('productReturn')
  productReturn: QueryList<SdOrderReturnDetailComponent>;

  updateProductList(product: IOrderReturnDetailProduct) {
    const index = this.productsSelected.findIndex(
      (p) => p.productCode === product.productCode,
    );
    if (index > -1) {
      this.productsSelected.splice(index, 1, product);
    } else {
      this.productsSelected.push(product);
    }
  }

  deselectProduct(productCode: string) {
    const index = this.productsSelected.findIndex(
      (p) => p.productCode === productCode,
    );
    if (index > -1) {
      this.productsSelected.splice(index, 1);
    }
  }

  returnProduct() {
    if (!this.productStatus()) {
      this.productSelectedDetails.emit(this.productsSelected);
    }
  }

  printReturnDetails() {
    this.printDetails.emit();
  }

  printReturnTicket() {
    this.printTicket.emit();
  }

  productStatus(): boolean {
    return this.productReturn.some((el: SdOrderReturnDetailComponent) => {
      return (
        el.checkValue === true &&
        el.reasonSelector.internalField.status === 'INVALID'
      );
    });
  }

  onopenRecommendedPriceModal() {
    this.openRecommendedPriceModal.emit();
  }
}
